import { useEffect, useRef, useState } from "react"

export function useWindowSize() {
  const [isResizing, setIsResizing] = useState(false)
  const resizeTimeoutRef = useRef(null)
  const [width, setWidth] = useState(
    typeof window === "undefined" ? 0 : window.innerWidth
  )

  useEffect(() => {
    function handleResize() {
      clearTimeout(resizeTimeoutRef.current)
      setIsResizing(true)
      resizeTimeoutRef.current = setTimeout(() => {
        setWidth(window.innerWidth)
        setIsResizing(false)
      }, 250) // debounce time
    }

    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
      clearTimeout(resizeTimeoutRef.current)
    }
  }, [])

  return { isResizing, width }
}
